import { ChannelsList } from '@components/Messages'
import { AppLayout } from '@layouts/AppLayout'
import { router } from 'expo-router'

export default function Channels() {
  return (
    <AppLayout
      backRoute={{ label: 'Página Inicial', back: () => router.replace('/') }}
    >
      <ChannelsList />
    </AppLayout>
  )
}
